const trackingUtils = require('od-modules/utils/tracking.utils');
const trackFrontEventsUtils = require('od-modules/track_events/track.frontevents.utils');

function getTracking($itemSelected) {
    const type = $itemSelected.is(':checked') ? 'checked' : 'unchecked';
    const categoryNumber = $itemSelected.data('categoryNumber');

    trackingUtils.trackEvent('results_filters_hotels', `hotel_rating_${categoryNumber}_${type}`);
}

function sendToFather(msg, evt) {
    this.$el.trigger(evt || 'filterHasChanged.accommodationfilter', msg);
}

module.exports = Odigeo.View.extend({
    ignoreModelUpdate: false,

    events: {
        'change .accommodationCategoryFilter:not(:disabled)': 'onUserCategorySelection',
        'change .accommodationCategoryFilter:checked': (evt) => trackFrontEventsUtils.trackClickEvent(evt),
    },

    onUserCategorySelection({currentTarget}) {
        const $itemSelected = $(currentTarget);
        const categoryNumber = $itemSelected.data('categoryNumber');
        const selectedItems = this.model.getRequestCategoryFilter(categoryNumber);

        sendToFather.call(this, {
            categoryFilterModel: [{selectedItems}],
        });
        getTracking.call(this, $itemSelected);
    },

    init() {
        this.$el.on('updateFilterStatus.accommodationfilter', Odigeo._.bind(this.model.updateFilterStatus, this.model));
        this.$el.on('resetFilterStatus.accommodationfilter', Odigeo._.bind(this.cleanCategoryFilter, this));
    },

    beforeInsertTemplate() {
        let isActive = false;
        const categories = Odigeo._.reduce(this.model.get('items'), function(memo, value, index) {
            isActive = Odigeo._.gt(value, 0);
            memo[index] = {
                disabled: !isActive ? 'disabled="disabled"' : '',
                key: index,
                checked: isActive && this.model.hasSelectedItem(index) ? 'checked="checked"' : '',
                value: value,
            };
            return memo;
        }, {}, this);

        return Odigeo._.extend({}, this.model.toJSON(), {categories});
    },

    render() {
        if (this.model.hasItems()) {
            this.setTemplate(this.$el, 'categories');
        }
    },

    cleanCategoryFilter() {
        sendToFather.call(this, {
            categoryFilterModel: [{selectedItems: []}],
        });
    },
});
